import styled from "styled-components";
import {FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaTiktok} from "react-icons/fa";
import logo from "../assets/images/logo.png";
import {useState} from "react";
import {message} from "antd";

const FooterContainer = styled.footer`
    background: rgb(31, 1, 16);
    color: #fff;
    padding: 40px 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 768px) {
        padding: 10px 5px 0;
    }
`;

const FooterContent = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
`;

const FooterSection = styled.div`
    flex: 1;
    min-width: 220px;
    margin: 15px;
`;

const FooterHeader = styled.h3`
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    color: #58a6ff;
`;

const FooterText = styled.p`
    margin: 5px 0;
    padding: 6px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
`;

const FooterLink = styled.a`
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    margin: 5px 0;
    display: block;
    transition: color 0.3s ease;

    &:hover {
        color: lightblue;
    }
`;

const LogoImage = styled.img`
    height: 50px;
    margin-bottom: 10px;
`;

const SocialIcons = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;

    a {
        color: #fff;
        margin: 0 10px;
        font-size: 22px;

        &:hover {
            color: lightblue;
            transition: color 0.4s ease;
        }
    }
`;

const Divider = styled.hr`
    border: none;
    border-top: 1px solid #00c3ff;
    width: 100%;
    margin-top: 30px;
`;

const Copyright = styled.p`
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
`;

const NewsletterInput = styled.input`
    padding: 10px;
    border-radius: 4px;
    border: none;
    margin-top: 10px;
    width: 100%;
    max-width: 250px;
    background: #1e1e1e;
    color: #fff;

    &:focus {
        outline: 2px solid #58a6ff;
    }
`;

const NewsletterButton = styled.button`
    margin-top: 10px;
    padding: 10px 15px;
    background: #58a6ff;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
        background: #007acc;
    }

    &:disabled {
        background: #aaa;
        cursor: not-allowed;
    }
`;

const Footer = () => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");

    const HandleClick = () => {
        setLoading(true);
        console.log(email);

        if (!/\S+@\S+\.\S+/.test(email)) {
            message.error("Please enter a valid email address.");
            return;
        }

        setTimeout(() => {
            setLoading(false);
            setEmail("");
            message.success("Subscribe successfully");
        }, 700);
    };

    return (
        <FooterContainer>
            <FooterContent>
                <FooterSection>
                    <LogoImage src={logo} loading="lazy" alt="Xtiim Record Label Logo" />
                    <FooterHeader>Lagos State Office</FooterHeader>
                    <FooterText>
                        <br />
                        ikeja Lagos Nigeria
                    </FooterText>
                    <FooterText>
                        <a href="tel:+19178367151" style={{color: "inherit", textDecoration: "none"}}>
                            +234 813 246 8134
                        </a>
                    </FooterText>
                </FooterSection>

                <FooterSection>
                    <FooterHeader>What We Offer</FooterHeader>
                    <FooterLink href="#">Music Production</FooterLink>
                    <FooterLink href="#">Songwriting & Collabs</FooterLink>
                    <FooterLink href="#">Artist Mentorship</FooterLink>
                    <FooterLink href="#">Music Video Shoots</FooterLink>
                    <FooterLink href="#">Promotion & Distribution</FooterLink>
                </FooterSection>

                <FooterSection>
                    <FooterHeader>Quick Links</FooterHeader>
                    <FooterLink href="/Contact" rel="noopener noreferrer">
                        Contact Us
                    </FooterLink>
                    <FooterLink href="/xtiim-artists/registration" rel="noopener noreferrer">
                        Apply Now
                    </FooterLink>
                    <FooterLink href="/Artists" rel="noopener noreferrer">
                        Meet With The Artists
                    </FooterLink>
                </FooterSection>

                <FooterSection>
                    <FooterHeader>Stay Updated</FooterHeader>
                    <FooterText>Subscribe to our newsletter for the latest drops & updates.</FooterText>
                    <NewsletterInput
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        type="email"
                        placeholder="Enter your email"
                    />
                    <NewsletterButton onClick={HandleClick} type="submit" disabled={loading}>
                        {loading ? "Subscribing..." : "Subscribe"}
                    </NewsletterButton>
                </FooterSection>
            </FooterContent>

            <SocialIcons>
                <a href="https://facebook.com/xtiimmusic" target="_blank" rel="noreferrer">
                    <FaFacebook />
                </a>

                {/* Instagram */}
                <a href="https://instagram.com/xtiimmusic" target="_blank" rel="noreferrer">
                    <FaInstagram />
                </a>

                {/* Twitter / X */}
                <a href="https://twitter.com/xtiimmusic" target="_blank" rel="noreferrer">
                    <FaTwitter />
                </a>

                {/* YouTube */}
                <a href="https://youtube.com/@xtiimmusic" target="_blank" rel="noreferrer">
                    <FaYoutube />
                </a>

                {/* TikTok (already working) */}
                <a href="https://tiktok.com/@xtiimmusic" target="_blank" rel="noreferrer">
                    <FaTiktok />
                </a>
            </SocialIcons>

            <Divider />

            <Copyright>
                &copy; {new Date().getFullYear()} XTiiM. All rights reserved. Built with creativity and passion. design
                by danovalab
            </Copyright>
        </FooterContainer>
    );
};

export default Footer;
